import './_navigation-menu-link.scss';

export default () => {};
